import React from 'react';
import './DiscordInvite.css';

// The invite to the Clomp Discord server
export const DISCORD_INVITE = 'https://discord.com/invite/GXjzggnh9y';

// The Discord icon on its own, pinned to the bottom left corner of the page
export function DiscordFloatingButton() {
    return (
        <a className="discord-float" href={DISCORD_INVITE} target="_blank" rel="noopener noreferrer" aria-label="Join the Clomp Discord" title="Join the Clomp Discord">
            <img src="/img/discord-icon.png" alt="" />
        </a>
    );
}

// A labelled button, for use within a page's content
export function DiscordButton() {
    return (
        <a className="discord-btn" href={DISCORD_INVITE} target="_blank" rel="noopener noreferrer">
            <img src="/img/discord-icon.png" alt="" />
            Join the Discord
        </a>
    );
}
